<template>
  <v-autocomplete
    v-model="local_film_ids"
    outline
    :items="films"
    append-icon="$vuetify.icons.rms_movie"
    multiple
    :rules="[rules.required, rules.min_length(1)]"
    chips
    :label="$t('rms.field.select_films.label')"
    item-text="title"
    color="primary"
    item-value="id"
    :hint="
      $t(`${eventPrefix}.monetization.paid_screening.edit_warning`)
    "
    persistent-hint
    class="mb-3"
  >
    <template v-slot:selection="data">
      <v-chip
        close
        class="chip--select-multi primary--text grey lighten-3"
        @input="removeSelectedFilm(data.item)"
      >
        <v-avatar v-if="data.item.thumburls">
          <img :src="data.item.thumburls" />
        </v-avatar>
        {{ data.item.title[currentLocale] }}
      </v-chip>
    </template>
    <template v-slot:item="data">
      <v-list-tile avatar class="d-flex" @click="addSelectedFilm(data.item)">
        <v-list-tile-avatar v-if="data.item.thumburls">
          <img :src="data.item.thumburls" />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title
            v-html="data.item.title[currentLocale]"
          ></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
  </v-autocomplete>
</template>

<script>
import rules from "@/validation";

export default {
    name:"CreateScreenerAskFilm",
    props:{
      films:{
        default:function(){
          return [];
        }
      },
      film_ids:{
        type: Array,
        default:function(){
          return [];
        },
      },
      eventPrefix: {
        type: String,
        default: "screener",
      },
    },
    mounted(){
      this.local_film_ids = this.film_ids;
    },
    data(){
      return{
        rules,
        local_film_ids:[]
      }
    },
    watch:{
      local_film_ids:{
        deep:true,
        handler:function(){
          this.$emit("update:film_ids",this.local_film_ids);
        }
      },
      film_ids(){
        this.local_film_ids = this.film_ids;
      }
    },
    computed:{
      currentLocale() {
        return this.$i18n.locale;
      }
    },
    methods:{
      removeSelectedFilm(film) {
        const index = this.film_ids.indexOf(film.id);
        if (index >= 0) this.film_ids.splice(index, 1);
      },
      addSelectedFilm(film){
        // If already there, remove it
        if(this.film_ids.includes(film.id)){
          return this.removeSelectedFilm(film);
        }
        this.film_ids.push(film.id);
      }
    }
}
</script>

<style>

</style>
